jQuery('.collection__filters-title.sidebar-title').click(function() {
  jQuery('.collection__filters').toggle();
});

jQuery(document).ready(function () {
  jQuery(".at-title").click(function () {
    jQuery(this)
      .toggleClass("active")
      .next(".at-tab")
      .slideToggle()
      .parent()
      .siblings()
      .find(".at-tab")
      .slideUp()
      .prev()
      .removeClass("active");
  });
});

jQuery('.product-interaction.moneyback, .product-interaction.email-us, .product-interaction.share-this').wrapAll('<div class="box_three_wrap"></div>');
